<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off" (ngSubmit)="onSubmit()">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{amenityName ? amenityName : 'New Booking'}}</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Task Name ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Task Name</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="taskName" [(ngModel)]="taskName" maxlength="255">
                        </div>
                    </div>

                    <!-- ___ Due Date ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-4">
                            <label>Due Date</label>
                        </div>
                        <div class="col-md-8">
                            <mat-form-field>
                                <input matInput [(ngModel)]="date" name="date" [matDatepicker]="picker"
                                       [min]="currentTime" (focus)="picker.open()"
                                       (click)="picker.open()" placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- ___ Repeat Task ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Repeat Task</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control" name="repeat" [(ngModel)]="repeat">
                                <option [ngValue]="false">Does not repeat</option>
                                <option [ngValue]="true">Repeat</option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Reminders ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Reminders</label>
                        </div>
                        <div class="col-md-8 display-flex">
                            <input class="form-control m-r-sm"
                                   name="notificationInteger"
                                   [(ngModel)]="notificationInteger"
                                   maxlength="255"
                                   style="width: 70px;">
                            <select class="form-control" name="reminders"  [(ngModel)]="reminders">
                                <option [ngValue]="false">Does not repeat</option>
                                <option [ngValue]="true">Repeat</option>
                            </select>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4"></div>
                        <div class="col-md-8">
                            <span class="mtv-primary-color clickable">Add Notification</span>
                        </div>
                    </div>

                    <!-- ___ Notify ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Notify</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="email" [(ngModel)]="email" maxlength="255" placeholder="Enter email address">
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4"></div>
                        <div class="col-md-8">
                            <span class="mtv-primary-color clickable">Add Email Address</span>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button class="btn btn-primary submit-btn"
                                type="submit" [disabled]="disabledSubmit">
                            Save Task
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-modal/maintenance-calendar-modal.component.html